module.exports = __webpack_public_path__ + "img/partners_7.c422e599.png";